<template>
  <div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      getAccessToken: 'auth/getAccessToken',
    })
  },
  watch: {
    getAccessToken: async function() {
      this.registerAccount();
    }
  },
  mounted() {
    this.$store.dispatch('auth/setSigninLog',{type: 'signup_page_4_opened', 'signinusername': ''});
  },
  methods: {
    registerAccount() {
      this.$store.dispatch('auth/registerAccount');
      localStorage.setItem('signedup', '1');
      this.$router.push({ path: '/account/upload_docs'});
    },
  }
}
</script>
